var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { CertificatesContainer, Container, RewardsContainer } from './subcomponents';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import { getSelectedAccountId } from '../../../../../helpers/sessionAccountId';
import useRewards from '../../../../../hooks/useRewards';
import ErrorPage from '../../../../../ui/templates/ErrorPage';
import { LoadingWrapper } from '../../../../RewardsModalContent/ui/templates/ModalContent/subcomponents';
import { useRewardsPageContext } from '../../../context/rewardsPageContext';
import Certificates from '../../molecules/Certificates';
import RewardsTabs from '../RewardsTabs';
var RewardDetails = function () {
    var config = useRewardsConfigContext().config;
    var selectedAccountId = getSelectedAccountId();
    var _a = useRewardsPageContext(), isActiveRewardsTab = _a.state.isActiveRewardsTab, dispatch = _a.dispatch;
    var _b = useState('rewards'), activeTab = _b[0], setActiveTab = _b[1];
    if (!selectedAccountId) {
        throw new Error('selectedAccountId is not defined');
    }
    var _c = useRewards(), hasCertificateHistory = _c.hasCertificateHistory, isError = _c.isError, isLoading = _c.isLoading, clientId = _c.clientId;
    var handleTabChange = function () {
        return setActiveTab(function (prevTab) {
            return prevTab === 'rewards' ? 'certificate-history' : 'rewards';
        });
    };
    useEffect(function () {
        if (hasCertificateHistory) {
            dispatch({ hasCertificateHistory: hasCertificateHistory });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasCertificateHistory]);
    if (isError) {
        return (_jsx(ErrorPage, { config: config, analyticsEventOptions: { clientName: clientId } }));
    }
    if (isLoading) {
        return (_jsx(LoadingWrapper, { children: _jsx(VerticalCardLoader, {}) }));
    }
    var tabClass = isActiveRewardsTab
        ? 'rewards-tab'
        : 'certificate-history-tab';
    return (_jsxs(Container, __assign({ className: tabClass }, { children: [_jsx(RewardsContainer, { children: _jsx(RewardsTabs, { activeTab: activeTab, handleTabChange: handleTabChange }) }), isActiveRewardsTab && (_jsx(CertificatesContainer, { children: _jsx(Certificates, {}) }))] })));
};
export default RewardDetails;
